import axios, { AxiosResponse } from 'axios';
import { SellOffer, Trade } from '@/store/sellOffer/types';
import { Asset } from '@/store/asset/types';

const baseUrl = process.env.VUE_APP_EXPORO_TRADING_API_URL;

const BOND_URL = `${process.env.VUE_APP_EXPORO_MOCK_MY_TRADING_URL || baseUrl}/my/securities/bonds`;
const SELL_OFFER_URL = `${process.env.VUE_APP_EXPORO_MOCK_SELLOFFER_URL || baseUrl}/orderbook/selloffer`;
const TRADE_URL = `${process.env.VUE_APP_EXPORO_MOCK_TRADES_URL || baseUrl}/orderbook/trades`;
const MY_TRADES_URL = `${process.env.VUE_APP_EXPORO_MOCK_MY_TRADING_URL || baseUrl}/my`;
const USER_WALLET_URL = `${process.env.VUE_APP_EXPORO_MOCK_MY_TRADING_URL || baseUrl}/my/balance`;
const MY_SECURITIES_URL = `${process.env.VUE_APP_EXPORO_MOCK_MY_TRADING_URL || baseUrl}/my/securities/bonds`;

class TradingService {
  getAssetById(id: string): Promise<AxiosResponse<Asset>> {
    return axios.get(`${BOND_URL}/${id}`);
  }

  getAssets(): Promise<AxiosResponse<Asset>> {
    return axios.get(`${BOND_URL}`);
  }

  getSellOffers(): Promise<AxiosResponse<SellOffer[]>> {
    return axios.get(`${MY_TRADES_URL}/selloffers/active`);
  }

  cancelSellOffer(id: string): Promise<AxiosResponse<SellOffer>> {
    return axios.delete(`${SELL_OFFER_URL}/${id}`);
  }

  getTrades(): Promise<AxiosResponse<Trade[]>> {
    return axios.get(`${TRADE_URL}`);
  }

  getTradeHistory(): Promise<AxiosResponse<Trade[]>> {
    return axios.get(`${MY_TRADES_URL}/history`);
  }

  getActiveTrades(): Promise<AxiosResponse<Trade[]>> {
    return axios.get(`${MY_TRADES_URL}/trades/active`);
  }

  getPendingTrades(): Promise<AxiosResponse<Trade[]>> {
    return axios.get(`${MY_TRADES_URL}/trades/pending`);
  }

  getSellOfferById(id: string): Promise<AxiosResponse<SellOffer>> {
    return axios.get(`${SELL_OFFER_URL}/${id}`);
  }

  createSellOffer(sellOffer: SellOffer) {
    return axios.post(SELL_OFFER_URL, sellOffer);
  }

  getUserWallet() {
    return axios.get(`${USER_WALLET_URL}`);
  }

  createTradeSellOffer(id: string, tradeSellOffer) {
    return axios.post(`${SELL_OFFER_URL}/${id}/trades`, tradeSellOffer);
  }

  getMySecurities(): Promise<AxiosResponse<Asset[]>> {
    return axios.get(`${MY_SECURITIES_URL}`);
  }
}

export default new TradingService();